import Service from "../Service";

const resource = "householdallowancedetail/";

export default {
  save(had, requestID) {
    return Service.post(resource + "save", had, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: {
        requestID: requestID,
      },
    });
  },
};
